import { Modal, styled, TextField } from '@mui/material';

// add custom prop here position x and y
interface RootModalProps {
  position: { x: number; y: number };
  wide?: boolean;
}

export const RootModal = styled(Modal, {
  shouldForwardProp: (prop) => prop !== 'wide' && prop !== 'position',
})<RootModalProps>(({ theme, position, wide }) => ({
  display: 'block',
  position: 'absolute',
  zIndex: 1500, // Higher than default modal z-index to stay on top

  '& .modal-content': {
    width: wide ? 900 : 770,
    padding: 20,
    borderRadius: 8,
    maxHeight: '670px',
    overflow: 'visible',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: `translate(calc(-50% + ${position.x}px), calc(-50% + ${position.y}px))`,
    transition: 'none', // Disable transition when dragging

    '& .header': {
      display: 'flex',
      justifyContent: 'space-between',
      paddingBottom: 10,
      cursor: 'grab',

      '&.dragging': {
        cursor: 'grabbing',
      },
    },
    '& .btn-close': {
      color: theme.palette.text.primary,
    },
  },
}));

// Add this before your component definition
export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    '&:hover': {},
    '&.Mui-focused': {},
    '&.Mui-disabled': {},
  },

  // FilledInput specific styles
  '& .MuiFilledInput-root': {
    height: '60px',
    '&.MuiInputBase-sizeSmall': {},
  },

  // Input field styles
  '& .MuiInputBase-input': {},

  // Label styles
  '& .MuiInputLabel-root': {
    top: '5px',
    '&.Mui-focused': {
      color: theme.palette.error.main,
    },
    '&.Mui-error': {
      color: theme.palette.error.dark,
    },
    '&.Mui-disabled': {},
    '&.MuiInputLabel-shrink': {},
  },

  // Helper text styles
  '& .MuiFormHelperText-root': {},

  // Outlined and underline borders
  '& .MuiFilledInput-underline:after': {
    borderBottom: `2px solid ${theme.palette.error.main}`,
  },
  '& .MuiFilledInput-underline:before': {},
  '& .MuiFilledInput-underline:hover:not(.Mui-disabled):before': {},
  '& .MuiFilledInput-underline.Mui-error:after': {},
  '& .MuiFilledInput-underline.Mui-disabled:before': {},

  // Autocomplete specific styles
  '& .MuiAutocomplete-endAdornment': {},
  '& .first': {
    borderRadius: '8px 0 0 8px',
  },
  '& .last': {
    borderRadius: '0 8px 8px 0',
  },
  '& .middle': {
    borderRadius: '0',
  },
}));
